import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  ListGroup
} from 'react-bootstrap'
import { LeftSidebarView } from 'components/Sidebar'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import {
  ListItem
} from 'components/List'
import KanBoIcon from 'components/KanBoIcon'
import SettingsGeneral from './components/SettingsGeneral'
import DocumentSources from './components/DocumentSources'
import DocumentTemplateSources from './components/DocumentTemplateSources'
import Blockers from './components/Blockers'
import Users from '../Users'

export class Settings extends React.Component {
  static propTypes = {
    leftSidebar: PropTypes.object.isRequired,

    currentUserRoles: PropTypes.object.isRequired,
  }

  handleUsersClick = () => {
    this.props.leftSidebar.push(Users)
  }

  handleSettingsGeneralClick = () => {
    this.props.leftSidebar.push(SettingsGeneral)
  }

  handleDocumentSourcesClick = () => {
    this.props.leftSidebar.push(DocumentSources)
  }

  handleDocumentTemplateSourcesClick = () => {
    this.props.leftSidebar.push(DocumentTemplateSources)
  }

  handleBlockersClick = () => {
    this.props.leftSidebar.push(Blockers)
  }

  render () {
    const {
      currentUserRoles
    } = this.props

    return (
      <LeftSidebarView
        title={<FormattedMessage id='SETTINGS' />}
      >
        <ListGroup>
          {currentUserRoles['setup'] &&
            <ListItem
              borderedIcon
              icon={<KanBoIcon fixedWidth name='kanbo-16-settings' />}
              onClick={() => { window.open('/setup', '_blank') }}
            >
              <FormattedMessage id='LANDING_PAGE_GO_TO_SETUP' />
            </ListItem>
          }
          {currentUserRoles['board-manage'] &&
            <ListItem
              borderedIcon
              icon={<KanBoIcon fixedWidth name='kanbo-16-settings' />}
              onClick={this.handleSettingsGeneralClick}
            >
              <FormattedMessage id='GENERAL' />
            </ListItem>
          }
          <ListItem
            borderedIcon
            icon={<KanBoIcon fixedWidth name='kanbo-16-members' />}
            onClick={this.handleUsersClick}
          >
            <FormattedMessage id='USERS_HEADER' />
          </ListItem>
          {currentUserRoles['docsource-manage'] &&
            <ListItem
              borderedIcon
              icon={<KanBoIcon fixedWidth name='kanbo-16-document-sources' />}
              onClick={this.handleDocumentSourcesClick}
            >
              <FormattedMessage id='DOCUMENTS_SOURCES_HEADER' />
            </ListItem>
          }
          {currentUserRoles['docsource-manage'] &&
            <ListItem
              borderedIcon
              icon={<KanBoIcon fixedWidth name='kanbo-16-document-template-source' />}
              onClick={this.handleDocumentTemplateSourcesClick}
            >
              <FormattedMessage id='DOCUMENT_TEMPLATE_SOURCES' />
            </ListItem>
          }
          <ListItem
            borderedIcon
            icon={<KanBoIcon fixedWidth name='kanbo-16-block' />}
            onClick={this.handleBlockersClick}
          >
            <FormattedMessage id='BLOCKERS' />
          </ListItem>
        </ListGroup>
      </LeftSidebarView>
    )
  }
}

export default withLeftSidebar(Settings)
